import { render, staticRenderFns } from "./AnnouncementNew.vue?vue&type=template&id=7b0fa951"
import script from "./AnnouncementNew.vue?vue&type=script&lang=js"
export * from "./AnnouncementNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports